export class PhxCalendarConfiguration {
  public hourBegin: string;
  public hourEnd: string;
  public save: Function;
  public delete: Function;
  public edit: Function;
}

angular.module('ui-ng-calendar').factory('ngPhxCalendarConfiguration', function () {
  return new PhxCalendarConfiguration();
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/config/calendar_configuration.ts